import { handleActions } from 'redux-actions';
import { PASO_SIGUIENTE_F0, PASO_ANTERIOR_F0, PASO_ACTUAL_F0, LOGOUT } from '../actions';
import { CONSTANTES } from '../../web/utils/Constantes';

const stateDefault = {
    // pasoActual  : 0,
    // urlActual   : CONSTANTES.RUTA.buscarSiniestro,
    urlActual   : CONSTANTES.RUTA.blankpage,
    // totalPasos  : 0,
}

function actualizarURL(pasoActual, urlActual){
    
    switch (pasoActual) {
        case 'login':
            return CONSTANTES.RUTA.login;        
        case 0:
            return CONSTANTES.RUTA.blankpage;
        case 1:
            return CONSTANTES.RUTA.fotossiniestro;
        case 2:
            return CONSTANTES.RUTA.fotosfactura;
        case 3:
            return CONSTANTES.RUTA.gracias;
        default:
            return CONSTANTES.RUTA.login
    }
}

export default  handleActions(
    {
        [PASO_ANTERIOR_F0]: (state, action) => {
            let paso = state.urlActual;
            paso = action.payload.paso - 1;

            const url = actualizarURL(paso, state.urlActual);
            return Object.assign( {}, state, { pasoActual: paso, urlActual: url });
        },
        [PASO_SIGUIENTE_F0] : (state, action) => {
            let paso = state.urlActual;
            paso = action.payload.paso + 1;
            
            const url = actualizarURL(paso, state.urlActual);
            return Object.assign( {}, state, { pasoActual: paso, urlActual: url });
        },
        [PASO_ACTUAL_F0] : (state, action) => {
            return Object.assign( {}, state, { ...action.payload } );
        },
        [LOGOUT] : (state, action) => { 
            return Object.assign({}, stateDefault);
        },
    },
    stateDefault
  );



